export default function HollowCircle(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 28.3334C22.3638 28.3334 28.3333 22.3638 28.3333 15C28.3333 7.63622 22.3638 1.66669 15 1.66669C7.63621 1.66669 1.66667 7.63622 1.66667 15C1.66667 22.3638 7.63621 28.3334 15 28.3334Z"
        stroke="inherit"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
